import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PatientForm } from "../components/PatientForm";
import { patientApi } from "../services/api";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

export default function AddPatient() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data) => {
    setIsLoading(true);
    try {
      const patient = await patientApi.create(data);
      toast.success("Sportiv adăugat cu succes!");
      navigate(`/admin/patients/${patient.id}`);
    } catch (error) {
      console.error("Failed to create patient:", error);
      toast.error("Eroare la adăugarea sportivului. Încearcă din nou.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div data-testid="add-patient-page" className="page-container">
      {/* Back Link */}
      <Link to="/admin/patients">
        <Button
          variant="ghost"
          size="sm"
          className="mb-4 gap-2"
          data-testid="back-to-patients"
        >
          <ArrowLeft className="w-4 h-4" />
          Înapoi la Sportivi
        </Button>
      </Link>

      {/* Page Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-semibold tracking-tight" style={{ fontFamily: "'Work Sans', sans-serif" }}>
          Adaugă Sportiv Nou
        </h1>
        <p className="text-muted-foreground mt-1">
          Completează formularul medico-sportiv pentru înregistrare
        </p>
      </div>

      {/* Form */}
      <div className="max-w-4xl">
        <PatientForm
          onSubmit={handleSubmit}
          isLoading={isLoading}
          submitLabel="Adaugă Sportiv"
        />
      </div>
    </div>
  );
}
